import { render, staticRenderFns } from "./showInfo.vue?vue&type=template&id=02b007f5&scoped=true"
import script from "./showInfo.vue?vue&type=script&lang=js"
export * from "./showInfo.vue?vue&type=script&lang=js"
import style0 from "./showInfo.vue?vue&type=style&index=0&id=02b007f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b007f5",
  null
  
)

export default component.exports